import React from 'react';
import { Switch, SwitchProps } from 'react-native';
import { LIGHT_GRAY, SECONDARY_COLOR } from '../../styles/appColor';

export default function AppSwitch(props: SwitchProps) {
  return <Switch {...props} trackColor={{ false: LIGHT_GRAY, true: SECONDARY_COLOR }} />;
}
